import React from 'react'
import { Card, CardActionArea, CardContent, makeStyles, SvgIcon, Typography, useTheme } from '@material-ui/core'
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    cardsHome: {
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem",
        marginBottom: "2rem",
        textDecoration: "none"
    },
    cardIn: {
        borderTopColor: theme.palette.primary.main,
        borderTopStyle: "outset",
        borderTopWidth: "thick",
        marginRight: "1rem",
        marginLeft: "1rem",
        marginBottom: "1rem",
        borderRadius: 10,
        minHeight:150
    }
}));

const CardHome = ({ Icon, title, route, externo=false, handleFunction=null }) => {
    const classes = useStyles()
    const theme=useTheme()
    const history = useHistory();

    return (
        // <Link to={} style={{textDecoration:"none"}}>
            <Card variant="outlined" className={classes.cardIn} style={{borderTopColor: route === "" ? theme.palette.secondary.main : theme.palette.primary.main}} onClick={()=>{
                if(handleFunction){
                    handleFunction()
                }
                if(externo){
                    window.location.href=route
                }else{
                    if(route !== ""){
                        history.push(route)
                    }
                }
            }}>
                <CardActionArea style={{minHeight:150}}>
                    <CardContent style={{ textAlign: "center" }}>
                        <SvgIcon fontSize="large" style={{fontSize:"2.75rem"}}><Icon style={{fill:"none"}} /></SvgIcon>
                        <Typography variant="h6" color="secondary" style={{fontSize:17.5}} >{title}</Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
        // </Link>
    )
}

export default CardHome
